module.exports = __webpack_public_path__ + "img/well_eo_bg.95dcfe7b.png";